/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 2/18/16.
 */
'use strict';
angular.module('prism-ui.livefeed').service('LiveFeedEditService',
	function ($routeParams, $location, $route, $q, NotificationService, BreadcrumbService, _) {
		var self = this;
		var originalData;

		var closeEditView = function () {
			BreadcrumbService.clearBreadcrumbs();

			var rootPath = $route.current.$$route.rootRoute;
			var queryParams = '';
			_.forEach(self.rootQueryParams, function (value, key) {
				queryParams += key + '=' + value;
			});
			if (!!queryParams) {
				rootPath += '?' + queryParams;
			}

			self.resetServiceData();
			$location.url(rootPath);
		};

		self.resetServiceData = function () {
			self.editData = null;
			self.editorForm = null;
			self.tabRevertFunction = null;
			self.tabSaveFunction = null;
			self.EditDataResource = null;
			self.rootQueryParams = {};
			originalData = null;
		};

		self.getEditData = function () {
			var dataReady = $q.defer();
			if ($routeParams.id > -1) {
				self.editData = self.EditDataResource.get({id: $routeParams.id});
				self.editData.$promise.then(function (editData) {
					originalData = angular.copy(editData);
					dataReady.resolve(self.editData);
				});
			} else {
				self.editData = new self.EditDataResource();
				dataReady.resolve(self.editData);
			}
			return dataReady.promise;
		};

		self.revertEditData = function () {
			if (self.editData.id) {
				self.editData = angular.copy(originalData);
				self.editorForm.$setPristine();
				if (self.tabRevertFunction) {
					self.tabRevertFunction();
				}
			} else {
				closeEditView();
			}
		};

		self.saveEditData = function () {
			var savePromise = (self.editData.id > -1) ? self.editData.$update() : self.editData.$save();

			savePromise.then(function (contentData) {
				$route.updateParams({id: contentData.id});
				originalData = angular.copy(contentData);
				self.editorForm.$setPristine();
				if (self.tabSaveFunction) {
					self.tabSaveFunction();
				}
			});
			return savePromise;
		};

		self.exitEdit = function () {
			if (self.editData.id && self.editorForm.$pristine) {
				closeEditView();
			} else {
				NotificationService.createWarningNotification('You have unsaved changes.  Please save or revert.', '');
			}
		};

		self.resetServiceData();
	});
